import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { bp } from 'Styles/helpers';
import { rem } from 'polished';
import screen from 'superior-mq';
import objectPath from 'object-path';
import Container from '../../container';
import Grid from '../../grid';
import LazyImg from '../../lazy-img';
import UnstyledList from '../../unstyled-list';
import Waves from '../../waves';
import StaggerIn from '../../stagger-in';

const memberStyles = [
  `grid-column: 1 / span 5;
    grid-row: 4 / span 4;

    ${screen.below(bp.mobile, `
      grid-column: 1 / span 4;
      grid-row: 1 / span 2;
    `)};
  `,
  `grid-column: 9 / span 5;
    grid-row: 6 / span 4;

    ${screen.below(bp.mobile, `
      grid-column: 4 / span 4;
      grid-row: 4 / span 2;
    `)};
  `,
  `grid-column: 14 / span 5;
    grid-row: 3 / span 4;

    ${screen.below(bp.mobile, `
      grid-column: 8 / span 4;
      grid-row: 2 / span 2;
    `)};
  `,
  `grid-column: 14 / span 5;
    grid-row: 10 / span 4;
    z-index: 2;

  ${screen.below(bp.mobile, `
    grid-column: 8 / span 4;
    grid-row: 6 / span 4;
  `)};
  `,
  `grid-column: 22 / -1;
    grid-row: 6 / span 4;

    ${screen.below(bp.mobile, `
      grid-column: 10 / span 4;
      grid-row: 4 / span 4;
    `)};
  `,
];

const columnTwoStyles = `
  grid-column: 1 / 8;
  grid-row: 14 / -1;

  ${screen.below(bp.mobile, `
    grid-column: 2 / span 4;
    grid-row: 7 / span 2;
  `)};
`;

const columnSevenStyles = `
  grid-column: 13 / span 3;
  grid-row: 1 / -1;
  z-index: 2;

  ${screen.below(bp.mobile, `
    grid-column: 7 / span 2;
    grid-row: 1 / span 8;
  `)};
`;

const AboutBoardMembers = ({ title, boardMembers, id }) => {
  if (boardMembers.length < 1) return null;

  return (
    <BoardMemberSection id={id}>

      <Container>
        <StaggerIn>
          <BoardMemberGrid>

            <Grid.Item className="js-stagger" styles={columnSevenStyles}>
              <VertH2>{title}</VertH2>
            </Grid.Item>

            {boardMembers.map((member, i) => {
              if (!objectPath.has(member, 'fields.headshot.fields.file')) return null;

              return (
                <Grid.Item className="js-stagger" styles={memberStyles[i]} key={member.sys.id}>
                  <figure>
                    <LazyImg
                      width={186}
                      height={186}
                      src={`${member.fields.headshot.fields.file.url}?w=186&h=186&fit=thumb&q=70&fm=jpg&fl=progressive`}
                      alt={member.fields.name}
                    />
                  </figure>
                </Grid.Item>
              );
            })}

            <Grid.Item styles={columnTwoStyles}>
              <BoardMemberList>

                {boardMembers.map(member => (
                  <li key={member.sys.id}>
                    {member.fields.name}
                  </li>
                ))}

              </BoardMemberList>
            </Grid.Item>

          </BoardMemberGrid>
        </StaggerIn>
      </Container>

      <Waves position="bottom" alignment="bottom" height={250} />
    </BoardMemberSection>
  );
};

const BoardMemberSection = styled.section`
  position: relative;
  padding: 160px 0 260px;

  ${screen.below(bp.laptopSm, `
    padding: 120px 0 190px;
  `)}

  ${screen.below(bp.tablet, `
    padding: 80px 0 150px;
  `)}
`;

const BoardMemberGrid = styled(Grid)`
  max-width: 1060px;
  height: 730px;
  margin: auto;
  grid-template-columns: repeat(26, 1fr);
  grid-template-rows: repeat(16, 1fr);

  ${screen.below(bp.mobile, `
    height: auto;
    grid-template-columns: repeat(13, 1fr);
    grid-template-rows: repeat(6, 1fr);
    grid-gap: 0;
  `)};
`;

const VertH2 = styled.h2`
  writing-mode: vertical-lr;
  white-space: nowrap;
  transform: rotate(180deg);
`;

const BoardMemberList = styled(UnstyledList)`
  li {
    ${screen.below(bp.mobile, `
      font-size: ${rem(11)};
    `)};
  }
`;

AboutBoardMembers.propTypes = {
  title: PropTypes.string,
  boardMembers: PropTypes.array,
  id: PropTypes.string,
};

AboutBoardMembers.defaultProps = {
  boardMembers: [],
};

export default AboutBoardMembers;
